export const CATEGORIES_ROLES = [
  {
    'name': 'projects',
    'roles': {
      'project': true,
      'documents_audin_audit': false,
      'documents_audin_integration': false,
      'documents_audin_technical_visit': false,
      'documents_audin_revised_technical_visit': false
    }
  },
  {
    'name': 'supervision',
    'roles': {
      'supervision': true,
      'hyperis': false,
      'wan': false,
      'topology': false,
      'connected_devices': false,
    }
  },
  {
    'name': 'wifi',
    'roles': {
      'statistic_ssid': false,
      'ran': false,
      'ran_stime': false,
      'ran_stime_ro': false,
      'portal_advertisement': false,
      'statistic_customers': false,
      'cmt': false,
      'bypass': false,
      'access_point_zones': false,
      'ssid_monitoring': false,
      'ssid_monitoring_ro': false
    }
  },
  {
    'name': 'codes',
    'roles': {
      'codes': false,
      'planet_campus': false,
      'statistic_purchases': false,
      'statistic_coupons': false,
    }
  },
  {
    'name': 'stream_cast',
    'roles': {
      'stream_cast': false,
      'iptv_channels': false,
      'statistic_chromecast': false
    }
  },
  {
    'name': 'documents',
    'roles': {
      'documents_financial_report': false,
      'documents_indicator_report': false,
      'documents_other_documents': false,
      'documents_support_documentation': false,
    }
  },
  {
    'name': 'support',
    'roles': {
      'sav_stime': false,
      'requests': false
    }
  },
  {
    'name': 'other',
    'roles': {
      'api': false,
      'idl': false,
      'ilopex': false,
      'silent_mode': false,
      'speedtest': false,
      'voip': false,
    }
  },
  {
    'name': 'internal',
    'roles': {
      'wan_expert': false,
      'admin_fake': false,
      'wifirst_documents': false,
      'demo_mode': false
    }
  }
]